import { render, staticRenderFns } from "./BreakpointsObserver.vue?vue&type=template&id=fe96330c&"
import script from "./BreakpointsObserver.vue?vue&type=script&lang=ts&"
export * from "./BreakpointsObserver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports